import React, {
  useState,
  useEffect,
  useContext,
  userContext,
  useRef,
} from "react";
import mainContext from "../context/MainContext/mainContext";
import TabContent1 from "../components/TabContent1";
import { useDispatch } from "react-redux";
import { setSideTab } from "../../../../toolkit/slices/inventories/inventorySlice";
import { Tabs, Button, Dropdown, Spin, Pagination } from "antd";
import AuthorizationError from "../../AuthorizationError";
import accessCheckPromise from "../../../../../utils/accessCheck";
import { FaPencilAlt, FaFilter } from "react-icons/fa";
import { MutatingDots, ThreeDots } from "react-loader-spinner";
import { logoutUser } from "../../../../toolkit/slices/users/userSlice";

const ProposalContainer = () => {
  const {
    activeTab,
    setActiveTab,
    proposalsA,
    setProposalsA,
    proposalsP,
    setProposalsP,
    inventories,
    setInventories,
    selectedInv,
    setSelectedInv,
    proposalId,
    setProposalId,
    fetchProp,
    setFetchProp,
    activatePR,
    setActivatePR,
    showLoader,
    setShowLoader,
    sendingLoader,
    createdOptions,
    setCreatedOptions,
    clientOptions,
    setClientOptions,
    dates,
    setDates,
    emailProps,
    setEmailProps,
    filtersProposal,
    setFiltersProposal,
    paginationAccepted,
    setPaginationAccepted,
    paginationPending,
    setPaginationPending,
    loadingAccepted,
    setLoadingAccepted,
    loadingPending,
    setLoadingPending,
    fetchProposals,
    handleFiltering,
    handleDateChange,
    handleClearFilters,
    handlePaginationChangeAccepted,
    handlePaginationChangePending,
    filters,
    apiBaseUrl,
  } = useContext(mainContext);
  // const [activeTab, setActiveTab] = useState("1"); // State to keep track of active tab
  const presentationRef = useRef(null);
  // const [proposalsP, setProposalsP] = useState(); //P as in pending
  // const [proposalsA, setProposalsA] = useState(); //A as in Accepted
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [inventories, setInventories] = useState(null);
  // const [selectedInv, setSelectedInv] = useState(null);
  // const [proposalId, setProposalId] = useState(null);
  // const [fetchProp, setFetchProp] = useState(false); //this basically tells whether to fetch the proposals based on toggle
  // const [activatePR, setActivatePR] = useState(false);
  // const [showLoader, setShowLoader] = useState(false);
  // const [createdOptions, setCreatedOptions] = useState(null);
  // const [clientOptions, setClientOptions] = useState(null);
  // const [dates, setDates] = useState(null);
  // const [emailProps, setEmailProps] = useState({});
  // const [filtersProposal, setFiltersProposal] = useState({
  //   client: null,
  //   createdBy: null,
  //   dateRange: null,
  // });

  const dispatch = useDispatch();

  useEffect(() => {
    if (activeTab === "1") {
      fetchProposals("accepted");
    } else if (activeTab === "2") {
      fetchProposals("pending");
    }
  }, [fetchProp, filtersProposal, activeTab]);

  useEffect(() => {
    if (activeTab === "1") {
      fetchProposals("accepted");
    }
  }, [paginationAccepted.current, paginationAccepted.pageSize]);

  useEffect(() => {
    if (activeTab === "2") {
      fetchProposals("pending");
    }
  }, [paginationPending.current, paginationPending.pageSize]);

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    fetchOptionsForFilter();
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
  }, []);

  async function fetchOptionsForFilter() {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/proposalFilterData`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      let responseJson = await response.json();
      setCreatedOptions(responseJson.data.createdBy);
      setClientOptions(responseJson.data.clients);
    } catch (error) {
      console.error(`Error in fetching Options for Filter: ${error.message}`);
    }
  }

  const onChange = (key) => {
    setActiveTab(key);
  };

  // Define items for Tabs component
  const items = [
    { key: "1", label: "Accepted Proposals" },
    { key: "2", label: "Pending Proposals" },
  ];
  const itemsBDF = [{ key: "1", label: "BDF" }];
  // Function to render component based on active tab
  const renderTabContent = () => {
    if (!activatePR) {
      switch (activeTab) {
        case "1":
          return (
            <>
              <TabContent1
                proposals={proposalsA}
                accepted={true}
                downloadAllowed={true}
                loading={loadingAccepted}
              />
              {paginationAccepted.total > 0 && (
                <div
                  style={{
                    marginTop: "1rem",
                    marginBottom: "1rem",
                    textAlign: "center",
                  }}
                >
                  <Pagination
                    current={paginationAccepted.current}
                    pageSize={paginationAccepted.pageSize}
                    total={paginationAccepted.total}
                    onChange={handlePaginationChangeAccepted}
                    showSizeChanger
                    pageSizeOptions={["10", "20", "50"]}
                    showQuickJumper
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`
                    }
                  />
                </div>
              )}
            </>
          );
        case "2":
          return (
            <>
              <TabContent1
                proposals={proposalsP}
                accepted={false}
                downloadAllowed={false}
                loading={loadingPending}
              />
              {paginationPending.total > 0 && (
                <div
                  style={{
                    marginTop: "1rem",
                    marginBottom: "1rem",
                    textAlign: "center",
                  }}
                >
                  <Pagination
                    current={paginationPending.current}
                    pageSize={paginationPending.pageSize}
                    total={paginationPending.total}
                    onChange={handlePaginationChangePending}
                    showSizeChanger
                    pageSizeOptions={["10", "20", "50"]}
                    showQuickJumper
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`
                    }
                  />
                </div>
              )}
            </>
          );
        default:
          return null;
      }
    } else {
      switch (activeTab) {
        case "1":
          return null;
        default:
          return null;
      }
    }
  };

  if (access == false) {
    return <AuthorizationError />;
  }

  return (
    <>
      <div
        className="parent-padding-container"
        style={{
          backgroundColor: "white",
          padding: "0px 20px",
          borderRadius: "12px",
        }}
      >
        <div
          className="spec-loader"
          style={{ display: showLoader && !sendingLoader ? "flex" : "none" }}
        >
          <MutatingDots
            visible={true}
            height="100"
            width="100"
            color="#f5d442"
            secondaryColor="#f5d442"
            radius="12.5"
            ariaLabel="mutating-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />

          <div className="blinking-text">Downloading ..</div>
        </div>
        <div
          className="spec-loader"
          style={{ display: sendingLoader ? "flex" : "none" }}
        >
          <ThreeDots
            visible={true}
            height="100"
            width="100"
            color="#f5d442"
            secondaryColor="#f5d442"
            radius="12.5"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />

          <div className="blinking-text">May take few seconds...</div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          {!activatePR ? (
            <Tabs
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={onChange}
              items={items}
            />
          ) : (
            <Tabs
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={onChange}
              items={itemsBDF}
            />
          )}
          <Dropdown
            menu={{
              items: filters,
            }}
            placement="bottomRight"
            arrow
            trigger={["click"]}
          >
            <Button>
              <FaFilter />
            </Button>
          </Dropdown>
        </div>
        {renderTabContent()}
      </div>
    </>
  );
};

export default ProposalContainer;
